export default [
  {
    path: '/admin/payroll-templates',
    name: 'payroll-template',
    meta: { requiresAuth: true },
    component: () => import('@/pages/payroll/payroll-template/index.vue')
  }
]
